import { BaseError } from "./base.js";
export class InvalidUserOperationError extends BaseError {
    constructor(uo) {
        super(`Request is missing parameters. All properties on UserOperationStruct must be set. uo: ${JSON.stringify(uo, (_key, value) => typeof value === "bigint"
            ? {
                type: "bigint",
                value: value.toString(),
            }
            : value, 2)}`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidUserOperationError"
        });
    }
}
export class WaitForUserOperationError extends BaseError {
    constructor(request, error) {
        super(`Failed to find User Operation: ${error.message}`);
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: request
        });
    }
}
//# sourceMappingURL=useroperation.js.map